module.exports = __webpack_public_path__ + "img/palabras2silabasdibujo.b2093366.png";